var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/utils/class-utils';
import React, { forwardRef } from 'react';
export const Text = forwardRef((_a, ref) => {
    var { variant = 'default', disabled, className = '', children, htmlFor } = _a, props = __rest(_a, ["variant", "disabled", "className", "children", "htmlFor"]);
    const variantStyles = {
        default: 'text-gray-900',
        error: 'text-vjwDanger text-sm',
        description: 'text-typographySubHeadingTextColor text-typographySubheadingFontSize font-typographySubheadingFontWeight',
        label: 'text-typographyLabelsFontSize text-typographyLabelsTextColor font-typographyLabelsFontWeight',
        heading: 'text-typographyHeadingFontSize font-typographyHeadingFontWeight text-typographyHeadingTextColor',
    };
    const combinedClassName = `${variantStyles[variant]} ${cn({ 'opacity-50': disabled }, className)}`;
    if (variant === 'label') {
        return (_jsx("label", Object.assign({ ref: ref, className: combinedClassName, htmlFor: htmlFor }, props, { children: children })));
    }
    return (_jsx("p", Object.assign({ ref: ref, className: combinedClassName }, props, { children: children })));
});
Text.displayName = 'Text';
